import React from 'react';
import '../../components/egmMap/content/mapStyle.css';
import MapContent from 'components/egmMap/content/MapContent';
import PropTypes from 'prop-types';
import MapBanner from '../../components/egmMap/banner/mapBanner';
import MapFooter from '../../components/egmMap/footer/mapFooter';

import config from '../../services/config';

class EgmMapPage extends React.Component {
  constructor( props ) {
    super( props );
    const urlElements = window.location.href.split( '/' );

    const params = Object.fromEntries(new URLSearchParams(window.location.search));
    let lang = 'en';
    if (params.lang !== undefined && ['en', 'es'].includes(params.lang) >= 0) {
      lang = params.lang;
    }
    let projectString = urlElements[4];
    if ( projectString.indexOf( '?' ) >= 1 && ( urlElements[3] === 'egm' || urlElements[3] === 'egm-draft' || urlElements[3] === 'egm-embedded' ) ) {
      const projectStringArray = projectString.split( '?' );
      projectString = projectStringArray[0];
      // window.location.href = `/${urlElements[3]}/${projectStringNew}`;
    }

    this.state = {
      path: projectString,
      path_token: projectString,
      path_type: urlElements[3],
      basic: null,
      projectdata: [],
      project_id: '',
      lang: lang,
    };
    this.fetchMyAPI();
  }

     static contextTypes = {
       router: PropTypes.object,
     }

     componentDidMount() {
       this.fetchMyAPI();
     }

 fetchMyAPI = async () => {
   let requestOptions = {};
   if ( this.state.path_type.includes( '-draft' ) ) {
     const draftProjectId = localStorage.getItem( `${this.state.path}_project_id` );
     requestOptions = {
       method: 'POST',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify( { url: this.state.path, draft: draftProjectId } ),
     };
   } else {
     requestOptions = {
       method: 'POST',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify( { url: this.state.path } ),
     };
   }
   const response = await fetch( `${config.url}project_details`, requestOptions );
   const { data } = await response.json();

   if ( data.length === 0 ) {
     this.setState( { projectdata: data } );
     localStorage.setItem( `${this.state.path}_project_id`, 'null' );
     this.context.router.history.push( '/' );
   } else {
     this.setState( { projectdata: data } );
     
     localStorage.removeItem( `${this.state.path}_project_id` );
     localStorage.removeItem( `${this.state.path}_apidata` );
     localStorage.removeItem( `${this.state.path}_orignalinterdata` );
     localStorage.removeItem( `${this.state.path}_orignaloutcomedata` );
     localStorage.removeItem( `${this.state.path}_mapOutcomeData` );
     localStorage.removeItem( `${this.state.path}_mapInterventionData` );

     localStorage.setItem( `${this.state.path}_project_id`, data.project_id );
     this.setState( { project_id: data.project_id } );
   }
 };

 render() {
   return (
     <div className="egmMapPage">
       { !( this.state.project_id === 57 && this.state.path_type === 'egm-embedded' ) && <MapBanner />}
       { this.state.project_id !== '' && <MapContent />}
       { !( this.state.project_id === 57 && this.state.path_type === 'egm-embedded' ) && <MapFooter />}
     </div>
   );
 }
}

export default EgmMapPage;
